export const API_URL = window.APP_CONFIG.API_URL;



/** WEBPACK FOOTER **
 ** ./app/config.js
 **/